const downloadFile = (fileBlobData: Blob, fileName: string) => {
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(new Blob([fileBlobData]));
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
};

export default downloadFile;
